import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    ChevronDown,
    Calendar as CalendarIcon,
    UserCheck,
    UserX,
    MoreHorizontal,
    Filter,
    Download
} from 'lucide-react';

export default function Attendance() {
    const [selectedStandard, setSelectedStandard] = useState('Standard - 8');
    const [selectedDivision, setSelectedDivision] = useState('Division - C');

    const [attendanceData, setAttendanceData] = useState([
        { sn: '01', id: 101, name: 'Alice Thompson', status: 'Present', date: '07/03/2026' },
        { sn: '02', id: 102, name: 'John Doe', status: 'Absent', date: '07/03/2026' },
        { sn: '03', id: 103, name: 'Michael Smith', status: 'Present', date: '07/03/2026' },
        { sn: '04', id: 104, name: 'Sarah Wilson', status: 'Pending', date: '07/03/2026' },
        { sn: '05', id: 105, name: 'David Brown', status: 'Present', date: '07/03/2026' },
        { sn: '06', id: 106, name: 'James Davis', status: 'Present', date: '07/03/2026' },
        { sn: '07', id: 107, name: 'Emma Miller', status: 'Absent', date: '07/03/2026' },
        { sn: '08', id: 108, name: 'Oliver Wilson', status: 'Present', date: '07/03/2026' },
    ]);

    const markAttendance = (id, newStatus) => {
        setAttendanceData(prev =>
            prev.map(student => student.id === id ? { ...student, status: newStatus } : student)
        );
    };

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Attendance Roll Call"
                    subtitle={`Viewing attendance for ${selectedStandard} • ${selectedDivision}`}
                    showStandardSelector={true}
                    showDivisionSelector={true}
                    selectedStandard={selectedStandard}
                    selectedDivision={selectedDivision}
                    setSelectedStandard={setSelectedStandard}
                    setSelectedDivision={setSelectedDivision}
                >

                    <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50">
                        <Download size={18} className="text-gray-400" />
                        Export
                    </button>
                </Header>

                {/* Main Content Table Card */}
                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <div className="flex items-center gap-6">
                            <h3 className="text-[20px] font-black text-[#111827]">Student attendance list</h3>
                            <div className="flex items-center gap-4">
                                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-lg text-[12px] font-black">92% Present</span>
                                <span className="text-gray-400 font-bold text-[14px]">Total 180 Students</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm cursor-pointer hover:bg-gray-50 transition-all">
                                <CalendarIcon size={18} className="text-gray-400" />
                                <span>March 07, 2026</span>

                            </div>
                            <button className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors">
                                <MoreHorizontal size={22} />
                            </button>
                        </div>

                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">S/N</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Student Name</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Roll No.</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Date</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Status</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attendanceData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5 text-[14px] font-bold text-gray-500">{v.sn}</td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-3">
                                                <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-[12px] font-black text-slate-500 overflow-hidden group-hover:bg-blue-50 group-hover:text-blue-600 transition-all">
                                                    {v.name.charAt(0)}
                                                </div>
                                                <span className="text-[15px] font-black text-[#111827] group-hover:text-blue-600 transition-colors">{v.name}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-[14px] font-bold text-gray-700">{v.id}</td>
                                        <td className="px-6 py-5 text-[14px] font-bold text-gray-500">{v.date}</td>
                                        <td className="px-8 py-5">
                                            <span className={`text-[12px] font-black px-3 py-1.5 rounded-lg inline-block min-w-[80px] text-center ${v.status === 'Present' ? 'text-emerald-500 bg-emerald-50/50' :
                                                v.status === 'Absent' ? 'text-rose-500 bg-rose-50/50' :
                                                    'text-amber-500 bg-amber-50/50'
                                                }`}>
                                                {v.status}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-2">
                                                <button
                                                    onClick={() => markAttendance(v.id, 'Present')}
                                                    className={`p-2 rounded-lg transition-all ${v.status === 'Present' ? 'bg-emerald-500 text-white' : 'text-gray-400 hover:bg-emerald-50 hover:text-emerald-500'}`}
                                                >
                                                    <UserCheck size={18} strokeWidth={2.5} />
                                                </button>
                                                <button
                                                    onClick={() => markAttendance(v.id, 'Absent')}
                                                    className={`p-2 rounded-lg transition-all ${v.status === 'Absent' ? 'bg-rose-500 text-white' : 'text-gray-400 hover:bg-rose-50 hover:text-rose-500'}`}
                                                >
                                                    <UserX size={18} strokeWidth={2.5} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-8 border-t border-gray-50 flex items-center justify-between">
                        <div className="flex items-center gap-2 text-[14px] font-bold text-gray-400">
                            Showing 8 of 180 Students
                        </div>
                        <div className="flex items-center gap-3">
                            <button className="px-6 py-3 rounded-xl border border-gray-100 text-[14px] font-bold text-gray-600 hover:bg-gray-50 transition-all">Previous</button>
                            <button className="px-6 py-3 rounded-xl bg-blue-500 text-white text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">Next</button>
                        </div>
                    </div>
                </div>

                <div className="mb-10 flex justify-end">
                    <button className="px-12 py-4 bg-blue-500 text-white rounded-[18px] text-[16px] font-black shadow-xl shadow-blue-200 hover:bg-blue-600 transition-all active:scale-[0.98]">
                        Submit final attendance
                    </button>
                </div>
            </main>
        </div>
    );
}
